@for (warningGroup of warnings; track $index) {
  <div class="warning-group">
    <div class="warning-group-title">
      {{ warningGroup?.name?.isTranslatable ? (warningGroup?.name?.value | translate) : warningGroup?.name?.value }}:
    </div>

    <div class="warning-group-list">
      @for (warningItem of warningGroup.items; track $index) {
        <p class="warning-item">
          <span
            [innerHTML]="
              warningItem.message?.isTranslatable ? (warningItem.message?.value | translate) : warningItem.message.value
            "
          >
          </span>

          <a
            class="action-btn edit-btn"
            [href]="warningItem.link"
            [target]="'_blank'"
            (click)="$event.stopPropagation()"
          >
          </a>
        </p>
      }
    </div>
  </div>
}
